export enum ProfileFields {
  FULL_NAME = 'full_name',
  PHOTO = 'profile_photo',
  EMAIL = 'email',
}

export type TProfileValues = {
  [ProfileFields.FULL_NAME]: string;
  [ProfileFields.EMAIL]: string;
  [ProfileFields.PHOTO]: string | null;
};
